module.exports = __webpack_public_path__ + "static/media/clock-warning.615df1b2.svg";